import { UserLoginHistory, UserLoginHistoryReqeust, UserPageBrowserHistory } from './../models/userLoginHistory.model';
import { inject, Injectable } from '@angular/core';
import { PolarJService } from './polarj.service';
import { MODULE_SERVICE_NAME, PolarJServerModelContextPath } from '../constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatalakeService {

  private polarjService: PolarJService  = inject(PolarJService);


  createLoginHistory(request: UserLoginHistoryReqeust): Observable<UserLoginHistory> {
   return  this.polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_DATALAKE,
      modelName:PolarJServerModelContextPath.USER_LOGIN_HISTORY,
      para: request,
      singleData: true
    });
  }

  createPageBrowserHistory(request: UserPageBrowserHistory): Observable<UserPageBrowserHistory> {
    return this.polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_DATALAKE,
      modelName: PolarJServerModelContextPath.USER_BROWSER_HISTORY,
      para: request,
      singleData: true
    })
  } 
}
